import {h, Fragment} from "preact"
export default function RangeInput({ className , value , ...props}) {
    // return <input type="number" className={`ns-input-field ns-d-block ${className}`} {...props} />
    // {...props} ns-input-field 
    return <span type="number" className={`ns-d-block ${className}`}>{className === 'ns-range-from' ? `From $${value}` : `to $${value}`}</span>
}